import type {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";

import type {TableContextMenuParams} from "../../../../ui/elements/context-menu/editor/TableToolbar/openTableContextMenu";

import {setNodeAttribute} from "../../../utils/setNodeAttribute";
import {findTablePosByTargetPos} from "../../../utils/findTablePos";

export const minimizeTable = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: TableContextMenuParams) => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const tableNodePos = findTablePosByTargetPos(state.doc.resolve(targetPos));
    if (tableNodePos === undefined) {
        return false;
    }

    if (dispatch) {
        const tableNode = state.doc.nodeAt(tableNodePos);
        setNodeAttribute(state, tableNode!, tableNodePos, 'state', 'default', dispatch);
    }
    return true;
}

export const canMinimizeTable = (state: EditorState, params?: TableContextMenuParams) => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const tableNodePos = findTablePosByTargetPos(state.doc.resolve(targetPos));
    if (tableNodePos === undefined) {
        return false;
    }
    const tableNode = state.doc.nodeAt(tableNodePos)!;
    return tableNode.attrs.state !== 'default';
}

